// import { useMemo } from 'react'
import { useLockContract, useTokenContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function LockPlatformCoin(lockAddress: string): any {
  const contract = useLockContract(lockAddress, false)
  const platformCoin = useSingleCallResult(contract, 'platformCoin')?.result?.[0]
  const tokenContract = useTokenContract(platformCoin, false)
  const symbol: string = useSingleCallResult(tokenContract, 'symbol')?.result?.[0]
  return platformCoin && symbol ? symbol : ''
}

export default LockPlatformCoin
